<template>
  <loginLayout>
    <div class="box">
      <div>
        <a href="/index">
          <img class="login-name" src="../../assets/image/logo.png" alt=""/>
        </a>
      </div>
      <div class="login-box">
        <div class="flex-content-between">
          <h1 class="title">会员注册</h1>
          <router-link class="link" to="/login">去登录</router-link>
        </div>
        <div class="login-input mt-24">
          <div class="login-input-prefix">用户名：</div>
          <Input class="input-box" placeholder="请输入手机号码/邮箱" clearable v-model="form.name"></Input>
        </div>
        <div class="flex-content-between mt-24">
          <div class="login-input" style="width: 250px;">
            <div class="login-input-prefix">验证码：</div>
            <Input class="input-box" placeholder="请输入验证码" clearable v-model="form.code" @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"></Input>
          </div>
          <Button
            ref="smsBtn"
            class="sms-btn"
            shape="circle"
            height="60px"
            @click="refreshCode"
            :disabled="codeDisabled"
            style="width: 120px"
          >{{text}}</Button>
        </div>
        <div class="login-input mt-24">
          <div class="login-input-prefix">密码：</div>
          <Input class="input-box" placeholder="请输入密码" type="password" clearable v-model="form.password"></Input>
        </div>
        <div class="login-input mt-24">
          <div class="login-input-prefix">确认密码：</div>
          <Input class="input-box" placeholder="请再次输入密码" type="password" clearable v-model="form.confirmPassword"></Input>
        </div>
        <div class="flex-content-between" style="margin-top: 40px">
          <Checkbox class="bj-color-F85A36" v-model="agreement"> 我已阅读并同意遵守</Checkbox>
          <span class="color-2d8cf0 pointer" style="color: #F85A36" @click="agreementModel">《用户协议》</span>
          <span class="color-2d8cf0 pointer" style="color: #F85A36" @click="privacyModel">《隐私政策》</span>
        </div>
        <Button class="login-btn" type="primary" shape="circle" long :loading="loading" @click="submit">立即注册</Button>
      </div>
    </div>
    <!-- 服务协议 -->
    <rule-modal
      :show.sync="agreementModelShow"
      :content="agreementRuleContent"
      :title="agreementTitle"
    ></rule-modal>
    <!-- 隐私政策 -->
    <rule-modal
      :show.sync="privacyModelShow"
      :content="privacyRuleContent"
      :title="privacyRuleTitle"
    ></rule-modal>
    <Modal
        v-model="verifyshow"
        title="验证码"
        @on-ok="getCodeEvent"
        @on-cancel="verifyshow = false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
    </Modal>
  </loginLayout>
</template>

<script>
import loginLayout from "./components/loginLayout.vue";
import { getEncrypt } from "utils/encrypt";
import { getRegisterCode, register } from "api/user.js";
import ruleModal from "components/ruleModal.vue";
import agreement from "assets/rule/agreementRule";
import { API_BASE_URL } from "@/utils/config";
import privacyRule from "assets/rule/privacyRule";

export default {
  name: "sige",
  components: {
    loginLayout,
    ruleModal,
  },
  data() {
    return {
      agreement: false,
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      loading: false,
      // 服务协议
      agreementModelShow: false,
      agreementRuleContent: "",
      agreementTitle: "",
      // 隐私政策
      privacyModelShow: false,
      privacyRuleContent: "",
      privacyRuleTitle: "",
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text: "获取验证码",
      codeDisabled: false
    };
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}bjweb/sms/register/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    agreementModel() {
      this.agreementModelShow = true;
      if (!this.agreementRuleContent) {
        this.agreementRuleContent = agreement.content;
        this.agreementTitle = agreement.title;
      }
    },
    privacyModel() {
      this.privacyModelShow = true;
      if (!this.privacyRuleContent) {
        this.privacyRuleContent = privacyRule.content;
        this.privacyRuleTitle = privacyRule.title;
      }
    },
    // 获取验证码
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码或邮箱！");
        this.$refs.smsBtn.reset();
        return;
      }
      getRegisterCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.text = `${i--}秒后再获取`;
            this.codeDisabled = true
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 提交
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入手机号码/邮箱！");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码或邮箱！");
        return false;
      }
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      if (!this.form.password) {
        this.$Message.warning("请输入密码！");
        return false;
      }
      if (!this.form.confirmPassword) {
        this.$Message.warning("请再次输入密码！");
        return false;
      } else if (this.form.password !== this.form.confirmPassword) {
        this.$Message.warning("两次密码不正确！");
        return false;
      }
      if (!this.agreement) {
        this.$Message.warning("请仔细阅读并同意协议！");
        return false;
      }
      const data = {
        source: 1,
        siteUrl: "http://test-ccgateway.190.vip/",
        p1: getEncrypt(this.form.password),
        p2: getEncrypt(this.form.confirmPassword),
        phone: this.form.name,
        msg: this.form.code,
      };
      this.loading = true;
      register(data)
        .then((res) => {
          this.loading = false;
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("注册成功！");
            this.$router.replace("/login");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
  .box{
    padding: 60px 50px;
    .login-name{
      height: 70px;
    }
  }
  .login-box{
    margin-top: 20%;
    .login-input{
      border: 1px solid #dcdee2;
      border-radius: 60px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 28px;
      .login-input-prefix{
        width: 100px;
      }
      .input-box{
        ::v-deep .ivu-input{
          border: none;
          &:focus{
            box-shadow: none
          }
        }
      }
    }
  }
  .mt-24{
    margin-top: 24px;
  }
  .link{
    margin-left: 20px;
    color: #F85A36;
  }
  .f-link {
    color: #F85A36;
  }

  ::v-deep .login-btn {
    margin-top: 40px;
    height: 60px;
    font-size: 14px;
    font-weight: 400;
    background-color: #F85A36;
    border-color: #F85A36;
    &:hover{
      border-color: #F85A36;
    }
    &:focus{
      box-shadow: none;
    }
  }
  .verify-info {
    padding: 15px 30px;
  }
  .verify-label {
    background-color: #f7fafb;
    width: 80px;
    font-size: 14px;
    padding: 0 15px;
    line-height: 58px;
    text-align: center;
  }
  .verify-code {
    border: 1px solid #e9eaec;
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .verify-input {
    display: block;
    width: 100%;
    border: 1px solid #e9eaec;
    border-radius: 6px;
    outline: none;
    padding: 0 20px;
    line-height: 40px;
    box-sizing: border-box;
  }
  .verify-block {
    display: flex;
    justify-content: center;
    align-items: stretch;
    margin-left: 10px;
  }
  ::v-deep .ivu-modal-content {
    background-color: #fff!important;
  }
  .sms-btn ::v-deep {
    .ivu-btn {
      width: 100%;
      height: 100%;
      background-color: #F85A36;
      color: #fff;
      &:hover{
        border-color: #F85A36;
      }
    }
  }
</style>
